import { render, staticRenderFns } from "./MainChartSubTips.vue?vue&type=template&id=b1e006b2&scoped=true&"
import script from "./MainChartSubTips.vue?vue&type=script&lang=js&"
export * from "./MainChartSubTips.vue?vue&type=script&lang=js&"
import style0 from "./MainChartSubTips.vue?vue&type=style&index=0&id=b1e006b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e006b2",
  null
  
)

export default component.exports